"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prism_1 = require("./prism");

exports.Prism = prism_1.Prism;

var apply_prism_1 = require("./utils/apply-prism");

exports.applyPrism = apply_prism_1.applyPrism;

var detect_languages_1 = require("./utils/detect-languages");

exports.getLanguageMap = detect_languages_1.getLanguageMap;

var get_classname_1 = require("./utils/get-classname");

exports.getThemeClassName = get_classname_1.getThemeClassName;
exports.getLanguageClassName = get_classname_1.getLanguageClassName;

var languages_1 = require("./available/languages");

exports.availableLanguages = languages_1.default;

var themes_1 = require("./available/themes");

exports.availableThemes = themes_1.default;